module.exports = __webpack_public_path__ + "assets/img/home-group-photo-2025.36dfaae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-group-photo-2025.jpg
// module id = 584
// module chunks = 1